/* global axios */
import ApiClient from './ApiClient';

class TaxiDriversAPI extends ApiClient {
  constructor() {
    super('taxi_drivers', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { taxi_driver: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { taxi_driver: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new TaxiDriversAPI();
